module.exports = __webpack_public_path__ + "static/media/loxone-image-section-four-2.f50bae59.png";